<div class="shop-item" >
  <div class="shop-item-media">
    <a [routerLink]="['/product-details', product.sellProductTitle | businessSlug, product.sellProductInfoId]" height="291" title="{{product.sellProductTitle}}">
        <span *ngIf="!product.sellProductImageURL">
            <img alt="{{product.sellProductTitle}}" [src]="[serverImgUrl] + '/sellProducts/' + [product.sellProductImageURL] || '../../assets/images/shop/1.jpg'"/>
        </span>
        <span *ngIf="product.sellProductImageURL">
            <img alt="{{product.sellProductTitle}}" [src]="[serverImgUrl] + '/sellProducts/' + [product.sellProductImageURL] || '../../assets/images/shop/1.jpg'"/>
        </span>
        <div class="overlay"></div>
    </a>
    <div class="geodir_status_date gsd_open"><i class="fal fa-piggy-bank"></i>Sale {{product.sellProductDiscount}}%</div>
    <div class="add-tocart color-bg hide" (click)="addToCart(product)"><span>Add to cart</span></div>
    <div class="geodir-category-opt">
        <div class="listing-rating-count-wrap">
            <div class="review-score">{{feedAvg | number:'1.1-1'}}</div>
            <div class="listing-rating">
              <app-star-rating [rating]='feedAvg' [readonly]="true"></app-star-rating>
            </div>
            <br>
            <!-- <app-star-rating [rating='1'] [readonly]="false"></app-star-rating> -->
            <div class="reviews-count text-start"> {{feedTotal}} review </div>
        </div>
    </div>
  </div>
  <div class="shop-item_title"> 
    <h4> <a title="{{product.sellProductTitle}}" [routerLink]="['/product-details', product.sellProductTitle | businessSlug, product.sellProductInfoId]"> {{product.sellProductTitle}}</a></h4>
    <p class="text-start fw-normal mb-2 short_info">{{product.sellProductDetails | shorten: 80: '...'}}</p>
    <span class="shop-item_price fs-6">
      <span class="discountPrice">{{product.sellProductPrice | currency:"₹"}} </span> -
      {{ finalDiscount | currency:"₹" }}
    </span>
    <a [routerLink]="['/product-details', product.sellProductTitle | businessSlug, product.sellProductInfoId]" class="btn-primary btn btn-sm pull-right">Details </a>
  </div>  
</div>